// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-view-customview-CustomViewFilterGroupDragPreview-module-dragPreview {
	background: var(--PrimaryWhite);
	border: 1px solid var(--Grey300);
	border-radius: 4px;
	gap: 4px;
	height: 40px;
	padding: 0 8px;
	width: 272px;
}`, "",{"version":3,"sources":["webpack://./src/csi/view/customview/CustomViewFilterGroupDragPreview.module.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,gCAAgC;CAChC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,cAAc;CACd,YAAY;AACb","sourcesContent":[".dragPreview {\n\tbackground: var(--PrimaryWhite);\n\tborder: 1px solid var(--Grey300);\n\tborder-radius: 4px;\n\tgap: 4px;\n\theight: 40px;\n\tpadding: 0 8px;\n\twidth: 272px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragPreview": `csi-view-customview-CustomViewFilterGroupDragPreview-module-dragPreview`
};
module.exports = ___CSS_LOADER_EXPORT___;
